export const Pagination = ({ pagination, setFormData }) => {
    const { page = 0, size = 10, totalElements = 0 } = pagination;
    const totalPages = Math.ceil(totalElements / size);

    if (totalPages <= 1) return null;

    const maxPagesToShow = 10;
    let startPage = 0;
    let endPage = totalPages - 1;

    if (totalPages > maxPagesToShow) {
        startPage = Math.max(0, page - Math.floor(maxPagesToShow / 2));
        endPage = startPage + maxPagesToShow - 1;
        if (endPage >= totalPages) {
            endPage = totalPages - 1;
            startPage = endPage - maxPagesToShow + 1;
        }
    }

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    const handlePrevPage = () => {
        if (page > 0) {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    page: page - 1,
                },
            }));
        }
    };

    const handleNextPage = () => {
        if (page < totalPages - 1) {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    page: page + 1,
                },
            }));
        }
    };

    const handlePageClick = (pageNumber) => {
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: pageNumber,
            },
        }));
    };

    return (
        <div className="table-pagination">
            <div className="pagination">
                <div className="btn-prev" onClick={handlePrevPage}></div>
                <ul className="page-list">
                    {startPage > 0 && (
                        <li key="first" className="first" onClick={() => handlePageClick(0)}>
                            1
                        </li>
                    )}
                    {pageNumbers.map((pageNumber) => (
                        <li key={pageNumber} className={page === pageNumber ? "active" : ""} onClick={() => handlePageClick(pageNumber)}>
                            {pageNumber + 1}
                        </li>
                    ))}
                    {endPage < totalPages - 1 && (
                        <li key="last" className="last" onClick={() => handlePageClick(totalPages - 1)}>
                            {totalPages}
                        </li>
                    )}
                </ul>
                <div className="btn-next" onClick={handleNextPage}></div>
            </div>
        </div>
    );
};
